import React, { useContext, useEffect, useState } from "react";
import "./panvel.css";
import { useLayerFunc } from "../Main/layerFunc";
import { GlobalContext } from "../../App";

function PanvelWardProj() {
  const { LayerChange, TileLayerChange, handleOpen } = useLayerFunc();
  const { SetLogout } = useContext(GlobalContext);

  useEffect(() => {
    SetLogout(true);
  }, []);

  return (
    <>
      <details
        className="baseline"
        onToggle={() => handleOpen("Panvel_Ward_Boundary")}
      >
        <summary>Panvel-Ward</summary>
        <div className="baseline-cont">
          <div className="opt-div">
            <input
              value="Panvel_Ward_Boundary"
              id="Panvel_Ward_Boundary"
              className="form-check-input check-map"
              type="checkbox"
              onChange={(e) =>
                LayerChange(e.target.value, e.target.id, e.target.checked)
              }
            />
            <label>Boundary</label>
          </div>
          <details id="townD">
            <summary className="townS">Baseline</summary>
            <div className="town-cont">
              <div className="opt-div">
                <input
                  value="Panvel_Ward_Baseline_Road_Network"
                  id="Panvel_Ward_Baseline_Road_Network"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Road</label>
              </div>

              <div className="opt-div">
                <input
                  value="Panvel_Ward_Baseline_Railway"
                  id="Panvel_Ward_Baseline_Railway"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Railways</label>
              </div>
               <div className="opt-div">
                  <input
                    value="Panvel_Ward_Town_Planning_trees"
                    id="Panvel_Ward_Town_Planning_trees"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Tree</label>
                </div>

                <div className="opt-div">
                  <input
                    value="Panvel_Ward_Town_Planning_Waterbody"
                    id="Panvel_Ward_Town_Planning_Waterbody"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(
                        e.target.value,
                        e.target.id,
                        e.target.checked,
                        false,
                        true
                      )
                    }
                  />
                  <label>Waterbody</label>
                </div>
              <div className="opt-div">
                <input
                  value="Panvel_Ward_Baseline_tb"
                  id="Panvel_Ward_Baseline_tb"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Total Builtup</label>
              </div>
            </div>
        </details>

            <details id="townD">
              <summary className="townS">Town Planning</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
                <div className="opt-div">
                  <input
                    value="Panvel_Ward_Town_Planning_Prabhag"
                    id="Panvel_Ward_Town_Planning_Prabhag"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Prabhag</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Panvel_Ward_Town_Planning_Panvel_Jurisdiction"
                    id="Panvel_Ward_Town_Planning_Panvel_Jurisdiction"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Jurisdiction</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Panvel_Ward_Town_Planning_Nodal_Sector"
                    id="Panvel_Ward_Town_Planning_Nodal_Sector"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Sectors</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Panvel_Ward_Town_Planning_Nodal_Plot_"
                    id="Panvel_Ward_Town_Planning_Nodal_Plot_"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Plots</label>
                </div>
                <div style={{ display: "none" }} className="opt-div">
                  <input
                    value="Panvel_Ward_Town_Planning_Village_Boundary"
                    id="Panvel_Ward_Town_Planning_Village_Boundary"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village Boundary</label>
                </div>
                <div style={{ display: "none" }} className="opt-div">
                  <input
                    value="Panvel_Ward_Town_Planning_Village_Survey"
                    id="Panvel_Ward_Town_Planning_Village_Survey"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village survey</label>
                </div>
               
              </div>
            </details>
          
           <details id="townD">
              <summary className="townS">Builtup Change</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
                <div className="opt-div">
                  <input
                    value="Panvel_authorised"
                    id="Panvel_authorised"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Authorised</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Panvel_Unauthorised"
                    id="Panvel_Unauthorised"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Unauthorised</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Panvel_Other_Authority"
                    id="Panvel_Other_Authority"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Other Authority</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Panvel_shed"
                    id="Panvel_shed"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Shed</label>
                </div>
                <div style={{ display: "none" }} className="opt-div">
                  <input
                    value="Panvel_total_builtup_jan2023"
                    id="Panvel_total_builtup_jan2023"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Total builtup jan2023</label>
                </div>
              </div>
            </details>

          <details id="townD">
            <summary className="townS">Images</summary>
            <div className="town-cont mb-3">
              <div className="opt-div">
                <input
                  value="Jan_2023"
                  id="Panvel_Ward_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "Jan 2023",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>Jan 2023</label>
              </div>
              <div className="opt-div">
                <input
                  value="March_2025"
                  id="Panvel_Ward_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "March 2025",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>March 2025</label>
              </div>
            </div>
          </details>
        </div>
      </details>
    </>
  );
}

export default PanvelWardProj;
